import sidebar, { en as sidebarEN, ca as sidebarCA } from './sidebar'
import teacher, { en as teacherEN, ca as teacherCA } from './teacher'
import student, { en as studentEN, ca as studentCA } from './student'
import newClass, { en as newClassEN, ca as newClassCA } from './newClass'
import presentationTab, { en as presentationTabEN, ca as presentationTabCA } from './presentationTab'
import valuation, { en as valuationEN, ca as valuationCA } from './valuation'

export default {
  sidebar,
  teacher,
  student,
  newClass,
  presentationTab,
  valuation,
  updatedAt: 'Actualizado el {date}',
  updatedAtBy: 'por {name}',
  updatedAtByYou: 'por ti',
  titlePlaceholder: 'Agregar un título a tu recurso',
  titleInfoTitle: 'Título del recurso',
  titleInfo: 'Elige un título para tu recurso. Intenta que sea atractivo y anticipatorio de la propuesta de trabajo.',
  topicsInfoTitle: 'Temáticas y sub-temáticas',
  topicsInfo: 'Indica qué temáticas y subtemáticas aborda este recurso. Puedes elegir una o dos temáticas y para cada temática una o dos subtemáticas. Recuerda que una correcta clasificación facilitará su búsqueda posterior. Con el ítem "Identidad institucional" podrás clasificar aquellos recursos que respondan a la visión y misión particular de tu centro. Si no encuentras una temática/subtemática que se ajuste, podrás seleccionar el ítem "Otras". Recuerda que una correcta clasificación facilitará su búsqueda posterior.'
}

export const en = {
  sidebar: sidebarEN,
  presentationTab: presentationTabEN,
  teacher: teacherEN,
  student: studentEN,
  valuation: valuationEN,
  newClass: newClassEN,
  updatedAt: 'Updated on {date}',
  updatedAtBy: 'by {name}',
  updatedAtByYou: 'by you',
  titlePlaceholder: 'Add a title to your resource',
  titleInfoTitle: 'Resource title',
  titleInfo: 'Choose a title for your resource. Try to make it attractive and anticipatory of the proposed work.',
  topicsInfoTitle: 'Topis and sub topics',
  topicsInfo: ''
}

export const ca = {
  sidebar: sidebarCA,
  presentationTab: presentationTabCA,
  teacher: teacherCA,
  student: studentCA,
  valuation: valuationCA,
  newClass: newClassCA,
  updatedAt: 'Actualitzat el {date}',
  updatedAtBy: 'per {name}',
  updatedAtByYou: 'per tu',
  titlePlaceholder: 'Afegir un títol al teu recurs',
  titleInfoTitle: 'Títol del recurs',
  titleInfo: 'Tria un títol per al teu recurs. Intenta que sigui atractiu i anticipatori de la proposta de treball',
  topicsInfoTitle: 'Temàtiques i sub-temàtiques',
  topicsInfo: ''
}
